import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { spin, pulse, shake, bounce, shimmer, pulseRed } from '../animations';

// --- Components ---

export const PulseAnimation = ({
  children,
  loading,
  lowBalance,
}: {
  children: React.ReactNode;
  loading: boolean;
  lowBalance: boolean;
}) => (
  <Box
    sx={{
      animation: loading
        ? `${pulse} 1.5s ease-in-out infinite`
        : lowBalance
          ? `${pulseRed} 1s ease-in-out infinite`
          : 'none',
    }}
  >
    {children}
  </Box>
);

export const ShakeAnimation = ({
  children,
  criticalBalance,
}: {
  children: React.ReactNode;
  criticalBalance: boolean;
}) => (
  <Box
    sx={{
      display: 'inline-block',
      animation: criticalBalance ? `${shake} 0.5s ease-in-out infinite` : 'none',
    }}
  >
    {children}
  </Box>
);

export const Spinner = ({ size = 16 }: { size?: number }) => (
  <Box
    sx={{
      width: size,
      height: size,
      border: '2px solid',
      borderColor: 'currentColor',
      borderTopColor: 'transparent',
      borderRadius: '50%',
      animation: `${spin} 1s linear infinite`,
      display: 'inline-block',
    }}
  />
);

export const SuccessCheckmark = () => (
  <Box
    sx={{
      width: 24,
      height: 24,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'success.main',
      color: 'common.white',
      animation: `${bounce} 0.5s ease-in-out`,
    }}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  </Box>
);

export const LoadingText = ({ text = 'Loading...' }: { text?: string }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 1,
    }}
  >
    <Spinner size={14} />
    <Typography
      variant="inherit"
      sx={{
        background: `linear-gradient(90deg,
          currentColor 25%,
          rgba(128, 128, 128, 0.5) 50%,
          currentColor 75%
        )`,
        backgroundSize: '200% 100%',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        color: 'transparent',
        animation: `${shimmer} 1.5s ease-in-out infinite`,
      }}
    >
      {text}
    </Typography>
  </Box>
);
